/**
 * CRM Multi-Compagnia · Audit Log
 */
import { useState } from "react";
import { Activity } from "lucide-react";
import {
  api, useApi, DataTable, Spinner, ErrorBox, TextInput, Select,
  fmtDateTime
} from "@/components/crm-multi/shared";

export default function CrmMultiAuditLogPage() {
  const [filters, setFilters] = useState({ action: "", actor_email: "", resource_type: "" });
  const list = useApi(() => api.get("/audit-logs", { ...filters, limit: 200 }), [filters]);

  return (
    <div className="space-y-4" data-testid="cm-audit-page">
      <header>
        <h2 className="text-lg font-semibold flex items-center gap-2"><Activity className="w-5 h-5" /> Audit log</h2>
        <p className="text-sm text-zinc-500">Eventi del CRM multi-compagnia · {list.data?.total ?? 0} record</p>
      </header>

      <div className="grid md:grid-cols-3 gap-2">
        <TextInput placeholder="Email attore..." value={filters.actor_email} onChange={(e) => setFilters({ ...filters, actor_email: e.target.value })} />
        <Select value={filters.action} onChange={(e) => setFilters({ ...filters, action: e.target.value })}>
          <option value="">Tutte le azioni</option>
          <option value="create">create</option><option value="update">update</option>
          <option value="delete">delete</option><option value="read_sensitive">read_sensitive</option>
          <option value="seed">seed</option><option value="promote_lead_to_policy">promote_lead</option>
        </Select>
        <Select value={filters.resource_type} onChange={(e) => setFilters({ ...filters, resource_type: e.target.value })}>
          <option value="">Tutti i tipi</option>
          <option value="insurance_company">insurance_company</option>
          <option value="insurance_product">insurance_product</option>
          <option value="crm_customer">crm_customer</option>
          <option value="policy">policy</option>
          <option value="payment">payment</option>
          <option value="claim">claim</option>
          <option value="insurance_company_credentials">insurance_company_credentials</option>
        </Select>
      </div>

      <ErrorBox error={list.error} />
      {list.loading ? <Spinner /> : (
        <DataTable
          testid="cm-audit-table"
          columns={[
            { key: "timestamp", label: "Quando", render: r => <span className="text-xs">{fmtDateTime(r.timestamp)}</span> },
            { key: "actor", label: "Utente", render: r => <span className="text-xs">{r.actor?.email || "system"}</span> },
            { key: "action", label: "Azione", render: r => <code className="text-xs">{r.action}</code> },
            { key: "resource_type", label: "Tipo", render: r => <code className="text-xs">{r.resource_type}</code> },
            { key: "resource_id", label: "ID", render: r => <code className="text-[10px] text-zinc-500">{r.resource_id?.slice(0, 8) || "—"}</code> },
            { key: "reason", label: "Motivo / IP", render: r => <span className="text-xs text-zinc-600">{r.reason || r.ip || "—"}</span> },
          ]}
          rows={list.data?.items || []}
          emptyTitle="Nessun evento audit"
        />
      )}
    </div>
  );
}
